import { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";

import { getLocalStorage } from "../../core/localStorageService";
import { PayloadProps } from "../../core/schema";
import apiEndpoint from "../../core/apiend_point";
import { triggerApi } from "../../services";
import moment from "moment";
import { Spinner } from "react-bootstrap";
import BackSecion from "../common/header";
import useRazorpay, { RazorpayOptions } from "react-razorpay";
import { ToWords } from 'to-words';
import "./fees.css"



/**
 * Renders Component.
//  * @return {FeeStu} renders Component.
 */
export default function FeeStu() {
  const user: any = JSON.parse(getLocalStorage("user") ?? "");
  const [studentFee, setStudentFee] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [orderId, setOrderId] = useState("");
  const [amount, setAmount] = useState(0);
  const [rajorPayGateway, setRaoprPayGateway] = useState({
    razorpay_enabled: 'false',
    razorpay_key: "",
    razorpay_secret: "",
  });
  useEffect(() => {
    getPaymentGatewayDetails()
    getStudentFee();
  }, []);

  const getPaymentGatewayDetails = () => {
    setIsLoading(true);

    const apiObject: PayloadProps = {
      payload: {
        auth_token: getLocalStorage("token"),
        user_id: user?.student[0]?.user_id,
      },
      method: "Get",
      apiUrl: apiEndpoint.paymentGatewayDetails,
    };

    triggerApi(apiObject)
      .then((res: any) => {
        if (res) {
          setRaoprPayGateway(res);
        }
      })
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const getStudentFee = () => {
    setIsLoading(true);

    const apiObject: PayloadProps = {
      payload: {
        auth_token: getLocalStorage("token"),
        user_id: user?.student[0]?.user_id,
      },
      method: "POST",
      apiUrl: apiEndpoint.getStudentFees,
    };

    triggerApi(apiObject)
      .then((res: any) => {
        if (res.data) {
          const newData = res.data.map((item: any) => {
            item.checked = false;
            return item;
          });
          setStudentFee(newData);
        }
      })
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const onFeeChange = (e: any, data: any) => {
    const existingData = [...studentFee];
    let selectedAmount: any = 0.0;
    const newData: any = existingData.map((item: any) => {
      if (item.id === e.target.value) {
        item.checked = !item.checked;
      }
      if (item.checked) {
        selectedAmount = parseFloat(
          selectedAmount + parseFloat(item.fee_amount)
        );
      }
      return item;
    });
    setStudentFee(newData);
    setAmount(selectedAmount);
  };

  const createOrder = () => {
    setIsLoading(true);
    const apiObject: PayloadProps = {
      payload: {
        auth_token: getLocalStorage("token"),
      },
      method: "GET",
      apiUrl: `${apiEndpoint.createRazorpayTxnId}/${amount}`,
    };

    triggerApi(apiObject)
      .then((res: any) => {
        if (res.data) {
          setOrderId(res.data);
          handlePayment(res.data);
        }
      })
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const Razorpay = useRazorpay();

  const handlePayment = async (orderid:string) => {
    console.log(rajorPayGateway)

    let fee_id:any = []
    let studen_fee_id:any = [];
   studentFee.map((item:any) => {
    if(item.checked === true){
      fee_id.push(item.fee_id);
      studen_fee_id.push(item.id);
    }
   });
   const toWords = new ToWords();
   let words = toWords.convert(amount, { currency: true, ignoreDecimal: true });
   
    //  await createOrder(); //'order_LVezJb3bgIxGkn';
    const options: RazorpayOptions = {
      key: `${rajorPayGateway.razorpay_key}`, //"rzp_live_L9J7U4ucvMudYr",
      amount: `${amount * 100}`,
      currency: "INR",
      name: "Skoolcom",
      description: "Fees",
      image: "https://example.com/your_logo",
      order_id: orderid,
      handler: (res) => {
        console.log(res);
      },
      prefill: {
        name: `${user?.student[0]?.name}`,
        email: `${user?.student[0]?.email}`,
        contact: `${user?.student[0]?.mobile}`,
      },
      notes: {
        address: "Razorpay Corporate Office",
        udf1 :user?.student[0]?.user_id,
        udf2: studen_fee_id.toString(),
        udf3: fee_id.toString(),
        udf4: `${words}`,
        udf5: user?.student[0]?.admission_type_id,
        udf6: user?.student[0]?.name,
        udf7: amount,
      },
      theme: {
        color: "#3399cc",
      },
      modal: {
        escape: false,
        ondismiss: false,
        confirm_close: true,
      },
      callback_url: apiEndpoint.razorpayCallBack,
    };
    console.log(options);
    const rzpay = new Razorpay(options);
    rzpay.on("payment.failed", function (response: any) {
      console.log(response);
      setStudentFee([]);
      setAmount(0);
      getStudentFee();
      //   {
      //     "error": {
      //         "code": "BAD_REQUEST_ERROR",
      //         "description": "No UPI App on this device. Select other UPI option to proceed.",
      //         "reason": "intent_no_apps_error",
      //         "metadata": {
      //             "payment_id": "pay_LVizA5YSp3IX51"
      //         }
      //     }
      // }
    });
    rzpay.on("payment.success", function (response: any) {
      console.log(response);
    //   {
    //     "razorpay_payment_id": "pay_LqbVDpM78SURcz",
    //     "razorpay_order_id": "order_LqbQVqsO8Eggcz",
    //     "razorpay_signature": "ea34745aa15caf7b1201825b07f4e42cfbf0a96f38563ab82ecd65636f892caa",
    //     "status_code": 200
    // }
    onPaymentSuccess(response)
      
    });

    rzpay.open();
  };

  const onPaymentSuccess = (response:any) => {
    let fee_id:any = []
    let studen_fee_id:any = [];
   studentFee.map((item:any) => {
    if(item.checked === true){
      fee_id.push(item.fee_id);
      studen_fee_id.push(item.id);
    }
   });
   setStudentFee([]);
   setAmount(0);
   const toWords = new ToWords();
   let words = toWords.convert(amount, { currency: true, ignoreDecimal: true });

   
    setIsLoading(true);
    const apiObject: PayloadProps = {
      payload: {
        razorpay_payment_id: response.razorpay_payment_id,
        amount:amount,
        udf1 :user?.student[0]?.user_id,
        udf2: studen_fee_id.toString(),
        udf3: fee_id.toString(),
        udf4: `${words}`,
        udf5: user?.student[0]?.admission_type_id,
        udf6: user?.student[0]?.name,
        udf7: amount,
        mihpayid : response.razorpay_payment_idment_id,
        txnid: response.razorpay_order_id,
        status:'captured'
      },
      method: "POST",
      apiUrl: `${apiEndpoint.razorpayCallBack}`,
    };

    triggerApi(apiObject)
      .then((res: any) => {
        
      })
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
        getStudentFee();
      });
    
  }

  return (
    <>
      <div className="cmmn px-3">
        <Container className="d-flex flex-column height_100vh">
          <BackSecion name="Fees" navigate_action="/home" />
          {isLoading && (
            <div className="loader">
              <Spinner animation="border" variant="primary" />
            </div>
          )}
          {!isLoading &&
            studentFee.length > 0 &&
            studentFee.map((item: any, i: number) => {
              return (
                <Row className="mt-075 mb-10" key={`fee-${i}`}>
                  <Col
                    xs="12"
                    className="mx-auto fee_std_bg rounded-3 px-3 py-2"
                  >
                    <Row className="justify-content-between">
                      <Col xs="8">
                        <p className="f-13 fw-bold m-0">{item.fee_name}</p>
                        <p className="status_clr f-12">
                          Status :
                          {item.due_amount > 0 ? (
                            <span className="nt_paid_clr ps-1">Not paid</span>
                          ) : (
                            <span className="paid_clr ps-1">Paid</span>
                          )}
                        </p>
                      </Col>
                      <Col
                        xs={2}
                        className="text-end f-14 fw-bold text-white ms-auto"
                      >
                        {item.due_amount > 0 && (
                          <Form.Check
                            aria-label="option 1"
                            checked={item.checked}
                            value={item.id}
                            onChange={(e: any) => onFeeChange(e, item)}
                          />
                        )}
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={5} className="f-12 status_clr">
                        <p className="m-0 dull_clr">Total Fee</p>
                        <div> ₹ {item.due_amount} </div>
                      </Col>
                      <Col xs={5} className="f-12 status_clr">
                        <p className="m-0 dull_clr status_clr">Due Date</p>
                        <div>{moment(item.due_date).format("DD MMM YYYY")}</div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              );
            })}

          {rajorPayGateway.razorpay_enabled === 'true' && <Row className="mt-17 mt-auto mb-3 justify-content-between"
          style={{position: 'sticky',
            bottom: '0px',
            paddingTop: '10px',
            background: "#fff",
            width: '100%',
            height: '50px',
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center',
            padding:"10px"
          }}
          >
            <Col xs={3} className="p-0">
              <p className="mb-0 f-11 status_clr">Total Amount</p>
              <p className="fw-bold f-14 mb-0">₹ {amount}</p>
            </Col>
            <Col xs={8} className="pe-0 d-grid gap-2">
              <button
                className="btn btn-primary btn-radius rounded-3 f-13"
                onClick={createOrder}
                disabled={amount ? false : true}
              >
                Pay now
              </button>
            </Col>
          </Row>}
        </Container>
      </div>
    </>
  );
}
